import * as React from 'react';

export const DashboardImage = () => {
  return <img alt="dashboard summary" src={'webdashboard.svg'} />;
};
